// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1_8UD","tableContainer":"styles_tableContainer__53oHg","rowsWrapper":"styles_rowsWrapper__2VuG6","loader":"styles_loader__2mR9I"};